(function ($) {
	$(function () {
		$("#Header .menu").on("click", function () {
			let windowWidth	=	$(window).innerWidth();
			
			$("body").toggleClass("noscroll");
			$(window).trigger("resize");

			setTimeout(function () {
				$("#Header .menu").toggleClass("opened");
				$(".navi").toggleClass("close");

				if($("body").hasClass("noscroll")) {
					$("#Navi").fadeIn();
				}
				else {
					$("#Navi").fadeOut();
				}
			}, 0);
		});

		$(window).on("resize", function () {
			$("#Navi").css({top: $("#Header").height()});
			$("#Navi > .inner > .contact").show();

			$("#Navi").css({height: ""});
			
			if($("#Navi > .inner").height() <= $(window).innerHeight() - $("#Header").height()) {
				$("#Navi").css({height: $(window).innerHeight() - $("#Header").height()});
			}
			else {
				$("#Navi").css({height: $("#Navi > .inner").height() - $("#Header").height()});
			}
		}).trigger("resize");
	});
})(jQuery);